import Vue from 'vue'
import App from './App'
import VuePlyr from 'vue-plyr'
import BootstrapVue from 'bootstrap-vue'
import VueResource from 'vue-resource'
import feather from 'vue-icon'
import router from './router'
import store from './store'
// import VueDraggable from 'vue-draggable'

import 'vue-plyr/dist/vue-plyr.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


Vue.use(BootstrapVue)
Vue.use(VuePlyr)
Vue.use(VueResource)
Vue.use(feather, 'v-icon')
// Vue.use(VueDraggable)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
